export const OFFER_LIMIT = 10;
